module.exports = new __parcel__URL__("henryschein_logo.3df738b8.jpeg").toString();